export default function Humanity( { socket } ) {
	return <div>CAH</div>;
}